import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ProfileSvg, LetterSvg } from "../../img/Image";
import styles from "./ModalInfo.module.css";
import InputField from "../ui/InputField";
import CodeInput from "../ui/CodeInput";
import Button from "../ui/Button";

export const ModalInfo = ({ isModalOpen, setIsModalOpen, info, onClick, labelButton }) => {
    const modalRef = useRef(null);
    const inputRef = useRef(null);
    const [isAnimating, setIsAnimating] = useState(false);

    const closeModalWithAnimation = () => {
        setIsAnimating(false);
        setTimeout(() => {
            setIsModalOpen(false);
        }, 200);
    };

    useEffect(() => {
        if (isModalOpen) {
            setIsAnimating(true);
            setTimeout(() => {
                if (inputRef.current) inputRef.current.focus();
            }, 100);
        }
    }, [isModalOpen]);

    return (
        <div className={`${styles.modalOverlay} ${isAnimating ? styles.modalOverlayVisible : ''}`}
            onClick={closeModalWithAnimation}
        >
            <div
                ref={modalRef}
                className={`${styles.modal} ${isAnimating ? styles.modalVisible : ''}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>Оповещение</h3>
                    <button
                        onClick={closeModalWithAnimation}
                        className={styles.modalCloseButton}
                        aria-label="Закрыть"
                    >
                        ×
                    </button>
                </div>

                <div className={styles.modalBody}>
                    <p>{info}</p>
                    <Button label={labelButton} onClick={onClick} />
                </div>
            </div>
        </div>
    )
}

export const ModalInfoCompleted = ({ isModalOpen, setIsModalOpen, info, onClick, labelButton }) => {
    const modalRef = useRef(null);
    const inputRef = useRef(null);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (isModalOpen) {
            setIsAnimating(true);
            setTimeout(() => {
                if (inputRef.current) inputRef.current.focus();
            }, 100);
        }
    }, [isModalOpen]);

    useEffect(() => {
        const handleEscKey = (e) => {
            if (e.keyCode === 27 && isModalOpen) {
                e.preventDefault(); // Предотвращаем закрытие по ESC
            }
        };

        if (isModalOpen) {
            document.addEventListener('keydown', handleEscKey);
        }

        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [isModalOpen]);

    return (
        <div className={`${styles.modalOverlay} ${isAnimating ? styles.modalOverlayVisible : ''}`} >
            <div
                ref={modalRef}
                className={`${styles.modal} ${isAnimating ? styles.modalVisible : ''}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>Оповещение</h3>
                </div>

                <div className={styles.modalBody}>
                    <p>{info}</p>
                    <Button label={labelButton} onClick={onClick} />
                </div>
            </div>
        </div>
    )
}


export const ModalInfoProfile = ({ isModalOpen, setIsModalOpen }) => {
    const navigate = useNavigate();
    const modalRef = useRef(null);
    const inputRef = useRef(null);
    const [isAnimating, setIsAnimating] = useState(false);

    const closeModalWithAnimation = () => {
        setIsAnimating(false);
        setTimeout(() => {
            setIsModalOpen(false);
        }, 200);
    };

    const HandleButton = () => {
        closeModalWithAnimation();
        navigate("/edit-profile");
    }

    useEffect(() => {
        if (isModalOpen) {
            setIsAnimating(true);
            setTimeout(() => {
                if (inputRef.current) inputRef.current.focus();
            }, 100);
        }
    }, [isModalOpen]);

    return (
        <div className={`${styles.modalOverlay} ${isAnimating ? styles.modalOverlayVisible : ''}`}
            onClick={closeModalWithAnimation}
        >
            <div
                ref={modalRef}
                className={`${styles.modalProfile} ${isAnimating ? styles.modalVisible : ''}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.modalHeaderProfile} style={{ padding: "20px 20px 0px 20px" }}>
                    <h3 className={styles.modalTitle}></h3>
                    <button
                        onClick={closeModalWithAnimation}
                        className={styles.modalCloseButtonProfile}
                        aria-label="Закрыть"
                    >
                        <svg viewBox="0 0 24 24" width="70" height="70" stroke="#000" strokeWidth="0.8" fill="none">
                            <path d="M6 6L18 18" />
                            <path d="M6 18L18 6" />
                        </svg>
                    </button>
                </div>

                <div className={styles.modalBody} style={{ padding: "0px 20px 70px 20px" }}>
                    <div className={styles.welcomContend}>
                        <div className={styles.profile}>
                            <ProfileSvg className={styles.profileImg} />
                        </div>
                        <h1 className={styles.completeTitle}>
                            Подача заявок станет доступна после заполнения профиля
                        </h1>
                        <div style={{ marginBottom: "20px" }}>
                            <Button label={"ЗАПОЛНИТЬ"} onClick={HandleButton} />
                        </div>
                        <div style={{ marginBottom: "20px" }}>
                            <button type="submit" className={styles.submitButton} onClick={closeModalWithAnimation}>
                                ПОЗЖЕ
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const ModalEventApplication = ({ isModalOpen, setIsModalOpen, onClick }) => {
    const modalRef = useRef(null);
    const inputRef = useRef(null);
    const [isAnimating, setIsAnimating] = useState(false);
    const [text, setText] = useState("");
    const [error, setError] = useState("");
    const MIN_CHARACTERS = 10; // Минимальное количество символов

    const closeModalWithAnimation = () => {
        setIsAnimating(false);
        setTimeout(() => {
            setIsModalOpen(false);
            setError(""); // Сбрасываем ошибку при закрытии
        }, 200);
    };

    const validateInput = () => {
        if (text.trim() === "") {
            setError("Пожалуйста, введите текст");
            return false;
        }

        if (text.trim().length < MIN_CHARACTERS) {
            setError(`Минимальная длина сообщения - ${MIN_CHARACTERS} символов`);
            return false;
        }

        setError("");
        return true;
    };

    const HandleButton = () => {
        if (validateInput()) {
            closeModalWithAnimation();
            onClick(text);
        }
    };

    const handleTextChange = (e) => {
        setText(e.target.value);
        // Сбрасываем ошибку при изменении текста
        if (error) {
            setError("");
        }
    };

    useEffect(() => {
        if (isModalOpen) {
            setIsAnimating(true);
            setText(""); // Сбрасываем текст при открытии
            setError(""); // Сбрасываем ошибку при открытии
            setTimeout(() => {
                if (inputRef.current) inputRef.current.focus();
            }, 100);
        }
    }, [isModalOpen]);

    return (
        <div className={`${styles.modalOverlay} ${isAnimating ? styles.modalOverlayVisible : ''}`}
            onClick={closeModalWithAnimation}
        >
            <div
                ref={modalRef}
                className={`${styles.modalProfile} ${isAnimating ? styles.modalVisible : ''}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.modalHeaderProfile} style={{ padding: "20px 20px 0px 20px" }}>
                    <h3 className={styles.modalTitle}></h3>
                    <button
                        onClick={closeModalWithAnimation}
                        className={styles.modalCloseButtonProfile}
                        aria-label="Закрыть"
                    >
                        <svg viewBox="0 0 24 24" width="70" height="70" stroke="#000" strokeWidth="0.8" fill="none">
                            <path d="M6 6L18 18" />
                            <path d="M6 18L18 6" />
                        </svg>
                    </button>
                </div>

                <div className={styles.modalBody} style={{ padding: "0px 20px 20px 20px" }}>
                    <div className={styles.bodyContend}>
                        <h1 className={styles.completeTitle}>
                            Расскажите, почему вы хотите участвовать в этом мероприятии
                        </h1>

                        <div className={styles.commentField}>
                            <textarea
                                ref={inputRef}
                                className={`${styles.commentInput} ${error ? styles.inputError : ''}`}
                                placeholder="Ваш комментарий..."
                                value={text}
                                onChange={handleTextChange}
                                rows={4}
                            />
                            {error && (
                                <div className={styles.errorContainer}>
                                    <span className={styles.errorText}>{error}</span>
                                    {text.trim().length > 0 && (
                                        <span className={styles.charCounter}>
                                            {text.trim().length}/{MIN_CHARACTERS}
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className={styles.buttonContainer}>
                            <div className={styles.submitButtonContainer}>
                                <Button
                                    label={"ОТПРАВИТЬ"}
                                    onClick={HandleButton}
                                    disabled={!text.trim() || text.trim().length < MIN_CHARACTERS}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const ModalChangeEmail = ({ isModalOpen, setIsModalOpen, changeEmail, confirmEmail }) => {
    const modalRef = useRef(null);
    const inputRef = useRef(null);
    const [change, setChange] = useState(true);
    const [isAnimating, setIsAnimating] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [timeLeft, setTimeLeft] = useState(60); // Таймер на 60 секунд
    const [canResend, setCanResend] = useState(false);
    const [email, setEmail] = useState("");
    const [code, setCode] = useState("");
    const [error, setError] = useState("");

    const [codeId, setCodeId] = useState("");

    const closeModalWithAnimation = () => {
        setIsAnimating(false);
        setTimeout(() => {
            setIsModalOpen(false);
            setError(""); // Сбрасываем ошибку при закрытии
        }, 200);
    };

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitted(true);

        if (!email) {
            setError("Пожалуйста, введите email");
            return;
        }

        if (!validateEmail(email)) {
            setError("Пожалуйста, введите корректный email");
            return;
        }

        const result = await changeEmail(email);
        if (result.errorBool) {
            setError(result.errorText);
        } else {
            setError("");
            setCodeId(result.codeID);
            setChange(false)
        }
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        // Сбрасываем ошибку при изменении email
        if (error && isSubmitted) {
            setError("");
        }
    };

    useEffect(() => {
        if (isModalOpen) {
            setIsAnimating(true);
            setEmail(""); // Сбрасываем текст при открытии
            setError(""); // Сбрасываем ошибку при открытии
            setTimeout(() => {
                if (inputRef.current) inputRef.current.focus();
            }, 100);
        }
    }, [isModalOpen]);



    useEffect(() => {
        // Если таймер уже истек, ничего не делаем
        if (timeLeft <= 0) {
            setCanResend(true);
            return;
        }

        // Устанавливаем интервал для уменьшения таймера каждую секунду
        const timer = setInterval(() => {
            setTimeLeft((prevTime) => {
                if (prevTime <= 1) {
                    setCanResend(true); // Устанавливаем canResend в true, когда время истекло
                    clearInterval(timer); // Очищаем интервал
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft]);

    useEffect(() => {
        if (error) {
            setError("");
        }
    }, [code]);

    const handleResendCode = () => {
        changeEmail(email);
        setTimeLeft(60);
        setCanResend(false);
        setError("");
    };

    const HandleButton = async () => {
        // Проверяем, что код полностью введен (4 цифры)
        if (code.length !== 4) {
            setError("Пожалуйста, введите полный код из 4 цифр");
            return;
        }
        const data = {
            email: email,
            code: code,
            codeId: codeId
        }
        const result = await confirmEmail(data);
        console.log(result)
        if (result === false) {
            setError("Неверный код. Пожалуйста, попробуйте еще раз");
        } else {
            setError("");
            closeModalWithAnimation();
        }

    };

    return (
        <div className={`${styles.modalOverlay} ${isAnimating ? styles.modalOverlayVisible : ''}`}
            onClick={closeModalWithAnimation}
        >
            <div
                ref={modalRef}
                className={`${styles.modalProfile} ${isAnimating ? styles.modalVisible : ''}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.modalHeaderProfile} style={{ padding: "20px 20px 0px 20px" }}>
                    <h3 className={styles.modalTitle}></h3>
                    <button
                        onClick={closeModalWithAnimation}
                        className={styles.modalCloseButtonProfile}
                        aria-label="Закрыть"
                    >
                        <svg viewBox="0 0 24 24" width="70" height="70" stroke="#000" strokeWidth="0.8" fill="none">
                            <path d="M6 6L18 18" />
                            <path d="M6 18L18 6" />
                        </svg>
                    </button>
                </div>

                <div className={styles.modalBody} style={{ padding: "0px 20px 70px 20px" }}>
                    <div className={styles.welcomContend}>
                        {change ? (
                            <>
                                <h1 className={styles.completeTitle}>
                                    Введите новую почту
                                </h1>
                                <InputField
                                    type="email"
                                    label="Электронная почта"
                                    value={email}
                                    onChange={handleEmailChange}
                                    error={isSubmitted && error}
                                    backColor={"#d9d9d9"}
                                />

                                <div style={{ marginTop: "10px" }}>
                                    <Button onClick={handleSubmit} label={"ПОЛУЧИТЬ КОД"} type="submit" />
                                </div>
                            </>
                        ) : (
                            <>
                                <h1 className={styles.completeTitle}>Подтверждение почты</h1>
                                <div className={styles.letter}>
                                    <LetterSvg className={styles.letterImg} />
                                </div>
                                <p className={styles.completeText}>
                                    На почту {email} отправлено письмо с кодом подтверждения.
                                </p>
                                <div style={{ marginTop: "20px", marginBottom: "25px" }}>
                                    <CodeInput value={code} onChange={setCode} />
                                    {error && (
                                        <div className={styles.errorTextDiv} style={{ textAlign: "center" }}>
                                            {error}
                                        </div>
                                    )}
                                </div>
                                <div style={{ marginBottom: "20px" }}>
                                    <Button label={"ПОДТВЕРДИТЬ"} onClick={HandleButton} />
                                </div>

                                {/* Блок с таймером и кнопкой повторной отправки */}
                                <div className={styles.resendCodeContainer}>
                                    {!canResend ? (
                                        <div className={styles.timerText}>
                                            Запросить код повторно через: {timeLeft} сек.
                                        </div>
                                    ) : (
                                        <button
                                            className={styles.resendButton}
                                            onClick={handleResendCode}
                                        >
                                            Запросить код снова
                                        </button>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}